// Helper function to send POST request
export const sendPostRequest = async (url, req) => {
    console.log("Request body:", req);  // Log request body

    return fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(req),
        credentials: "include", // Include cookies in the request
    });
};

// Helper function to send GET request
export const sendGetRequest = async (url, params = {}) => {
    // Build query string from params object
    const queryString = new URLSearchParams(params).toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;

    console.log("Request URL:", fullUrl);  // Log the full request URL

    return fetch(fullUrl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include", // Include cookies in the request
    });
};

// Helper function to send PUT request
export const sendPutRequest = async (url, req) => {
    console.log("Request body:", req); // Log request body

    return fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(req),
        credentials: "include", // Include cookies in the request
    });
};

// Helper function to handle response
export const handleResponse = async (response) => {
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({})); // Parse error response safely
        console.error(`HTTP error! Status: ${response.status}, Response: ${JSON.stringify(errorData)}`);

        // Create a custom error with the message from errorData (if available)
        const error = new Error(errorData?.message || `HTTP error: ${response.status}`);
        error.status = response.status; // Include status code for further handling
        error.data = errorData; // Attach full error data for debugging
        throw error; // Throw the custom error
    }

    return response.json();  // Parse and return successful response as JSON
};
